import React from 'react';
import PropTypes from 'prop-types';

const SVG = ({color = '#2F343B', width = '100%', height = '100%', className = ''}) => (
  <svg
    color={color}
    className={className}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/1999/xlink"
  >
    <title>Artboard</title>
    <desc>Created with Sketch.</desc>
    <g fill={color} id="Artboard" stroke="none" strokeWidth="1" fillRule="nonzero">
      <rect id="Rectangle" x="2" y="3" width="16" height="15" rx="7.5" />
    </g>
  </svg>
);

SVG.propTypes = {
  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  className: PropTypes.string,

  /**
   * Color hex code
   */
  color: PropTypes.string,

  /**
   * Icon width
   */
  width: PropTypes.string,

  /**
   * Icon height
   */
  height: PropTypes.string,
};

export default SVG;
